function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  transform: "translate(19) rotate(90)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4.886.209.272,4.016a.918.918,0,0,0-.272.4v.7a.964.964,0,0,0,.128.24.905.905,0,0,0,1.3.149L4.582,2.9V19H6.423V2.992l.035,0L9.5,5.5a.906.906,0,0,0,1.3-.149.975.975,0,0,0-.144-1.339L6.039.209a.9.9,0,0,0-1.153,0ZM4.614,2.872h0Z",
  transform: "translate(0)",
  fill: "#fff"
}));

function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 11,
    viewBox: "0 0 19 11"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOSIgaGVpZ2h0PSIxMSIgdmlld0JveD0iMCAwIDE5IDExIj48ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxOSkgcm90YXRlKDkwKSI+PHBhdGggZD0iTTQuODg2LjIwOS4yNzIsNC4wMTZhLjkxOC45MTgsMCwwLDAtLjI3Mi40di43YS45NjQuOTY0LDAsMCwwLC4xMjguMjQuOTA1LjkwNSwwLDAsMCwxLjMuMTQ5TDQuNTgyLDIuOVYxOUg2LjQyM1YyLjk5MmwuMDM1LDBMOS41LDUuNWEuOTA2LjkwNiwwLDAsMCwxLjMtLjE0OS45NzUuOTc1LDAsMCwwLS4xNDQtMS4zMzlMNi4wMzkuMjA5YS45LjksMCwwLDAtMS4xNTMsMFpNNC42MTQsMi44NzJoMFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDApIiBmaWxsPSIjZmZmIi8+PC9nPjwvc3ZnPg==";
export { SvgArrowRight as ReactComponent };